<template>
  <form class="form-contact" @submit.prevent="submitForm">
		<p class="title-form-contact">QUEREMOS CONOCERTE</p>
		<v-layout wrap>
			<v-flex xs12 mb-2>
				<input
				class="input-form"
				type="text"
				id="name"
				placeholder="Nombre"
				v-model="form.name"
				autocomplete="off"
				>
			</v-flex>
			<v-flex xs12 mb-2>
				<input
				class="input-form"
				type="email"
				id="email"
				placeholder="Correo"
				v-model="form.email"
				autocomplete="off"
				>
			</v-flex>
			<v-flex xs12 mb-2>
				<textarea
				class="input-form"
				v-model="form.commentary"
				placeholder="Mensaje"
				type="text"
				cols="4"
				rows="4"
				></textarea>
			</v-flex>
			<button class="btn-submit" :disabled="disabled">Enviar</button>
		</v-layout>
	</form>
</template>

<script>
import http from 'axios';

function disabled() {
	return !this.form.name || !this.form.email || !this.form.commentary;
}

async function submitForm() {
	const body = {
		companyId: process.env.COMPANY_ID,
		data: {
			email: this.form.email,
			from: process.env.FORM_FROM,
			fullName: this.form.name,
			message: process.env.FORM_MESSAGE,
			to: process.env.FORM_TO,
			commentary: this.form.commentary,
		},
		templateCode: process.env.TEMPLATE_CODE,
	};
	try {
		await http.post(`${process.env.FORM_URL}/notifications/EMAIL/public`, body);
		this.informationCustomer();
		this.showNotification('Su información ha sido enviada correctamente.');
	} catch (error) {
		if (error.status === 500) {
			this.showGenericError();
		}
	}
}


async function informationCustomer() {
	const body = {
		companyId: process.env.COMPANY_ID,
		data: {
			email: process.env.FORM_TO,
			from: process.env.FORM_FROM,
			fullName: this.form.name,
			message: process.env.FORM_MESSAGE,
			to: this.form.email,
			commentary: this.form.commentary,
		},
		templateCode: process.env.TEMPLATE_CONFIRM,
	};
	try {
		await http.post(`${process.env.FORM_URL}/notifications/EMAIL/public`, body);
		this.clearForm();
	} catch (error) {
		if (error.status === 500) {
			this.showGenericError();
		}
	}
}

function clearForm() {
	this.form = {
		email: '',
		name: '',
		message: '',
	};
}

function data() {
	return {
		form: {
			email: '',
			name: '',
			message: '',
		},
	};
}

export default {
	name: 'form-contact',
	data,
	methods: {
		clearForm,
		informationCustomer,
		submitForm,
	},
	computed: {
		disabled,
	},
};
</script>

<style lang="scss" scoped>
.form-contact {
	background-color: map-get($colors, white);
	box-shadow: 0 2px 53px 0 rgba(0, 0, 0, 0.07);
	max-width: 475px;
	padding: 45px 35px;
	position: relative;
	top: 105px;

	@media (max-width: 1024px) {
		margin: 0 30px;
		padding: 40px 24px;
		top: 50px;
	}

	@media (max-width: 380px) {
		margin: 0 10px;
	}
}

.title-form-contact {
	color: map-get($colors, blue-regular);
	font-family: 'Lato', sans-serif;
	font-weight: 900;
	font-size: 25px;
	margin-bottom: 50px;
	text-align: center;
}

.btn-submit {
	background-color: map-get($colors, base);
	border-radius: 9px;
	color: map-get($colors, white);
	font-family: 'Lato', sans-serif;
	font-weight: 900;
	font-size: map-get($sizes, xlarge);
	height: 60px;
	width: 100%;
}

.input-form {
	border: solid 1px #e1e1e1;
	border-radius: 9px;
	color: #d1d1d1;
	font-size: 18px;
	margin-bottom: 15px;
	padding: 20px 0 20px 18px;
	outline: none;
	width: 100%;
}
</style>


// WEBPACK FOOTER //
// src/components/home/form-contact.vue